import "./Grid.scss";

import * as React from "react";
import { Grid as KGrid } from "@progress/kendo-react-grid";

import type {
  GridProps as KGridProps,
  GridRowProps as KGridRowProps,
} from "@progress/kendo-react-grid";

interface GridProps extends React.PropsWithChildren<KGridProps> {
  disabled?: boolean;
}

export class Grid extends React.PureComponent<GridProps> {
  public static displayName = "KendoReactGrid";

  render() {
    // force rowHeight to be 40
    const { className, rowHeight, disabled, ...otherProps } = this.props;
    const isDisabled = typeof disabled !== "undefined" && disabled;

    return (
      <KGrid
        rowHeight={40}
        className={`tc-grid ${isDisabled ? "tc-grid-disabled" : ""} ${className}`}
        {...otherProps}
      />
    );
  }
}
export interface GridRowProps extends KGridRowProps {}
